import { SVGProps, Ref, forwardRef } from 'react';

export const CheckboxCheckSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m12 6-5.333 5.333-3-3 .848-.848 2.152 2.151 4.484-4.485z"
            fill="currentColor"
        />
    </svg>
));
CheckboxCheckSize16Glyph.displayName = 'CheckboxCheckSize16Glyph';
